import React, { useEffect, useState } from 'react';
import { Form, Input } from 'antd';
import { IUserAddressRulesField } from 'base/interfaces/address'
import { getFormItemRules } from '@base/account/address/utils'

type IProps = {
    itemRules: IUserAddressRulesField;
    currentCountryObj?: any;
}

const MobileFormItem: React.FC<IProps> = (props) => {
    const { itemRules, currentCountryObj } = props;
    const {
        key,
        labelTitle,
        placeholder,
        maxlength,
    } = itemRules;

    return (
        <Form.Item
            label={labelTitle}
            name={key}
            rules={getFormItemRules(itemRules)}
        >
            <Input
                // autoComplete="no-fill" // off 无效
                addonBefore={currentCountryObj ? `${currentCountryObj.code} +${currentCountryObj.countryPhonePrefix}` : ''}
                placeholder={placeholder}
                autoComplete={'no-fill'}
                {...(+maxlength > 0 ? {
                        maxLength: +maxlength
                    } : {}
                )}
            />
        </Form.Item>
    );
};

export default MobileFormItem